import { render, staticRenderFns } from "./pillarList.vue?vue&type=template&id=3194be3d"
import script from "./pillarList.vue?vue&type=script&lang=js"
export * from "./pillarList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports